import { Microfrontend } from '@thoughtspot/microfrontends';
import { loadMicroFrontendComponent } from './microfrontend-wrapper';
import { initMicroFrontend } from './microfrontends.util';

enum NavigationComponents {
    NavigationHub = 'NavigationHub',
}

export const NavigationHub = loadMicroFrontendComponent(
    Microfrontend.NAVIGATION,
    NavigationComponents.NavigationHub,
);

initMicroFrontend(Microfrontend.NAVIGATION);
